(function() {
  const variantMap = {"BLACK": {"iPhone 17 Pro Max": "59269385519449", "iPhone 17 Pro": "59269385945433", "iPhone 17": "59269385978201", "iPhone 16 Pro Max": "59269386010969", "iPhone 16 Pro": "59269386043737", "iPhone 16 Plus": "59269386076505", "iPhone 16": "59269386109273", "iPhone 15 Pro Max": "59269386142041", "iPhone 15 Pro": "59269386174809", "iPhone 15": "59269386207577", "iPhone 14 Pro Max": "59269386240345", "iPhone 14 Pro": "59269386273113", "iPhone 14 Plus": "59269386305881", "iPhone 14": "59269386338649", "iPhone 13 Pro Max": "59269386371417", "iPhone 13 Pro": "59269386404185", "iPhone 13": "59269386436953"}, "WHITE": {"iPhone 17 Pro Max": "59269386469721", "iPhone 17 Pro": "59269386502489", "iPhone 17": "59269387583833", "iPhone 16 Pro Max": "59269387616601", "iPhone 16 Pro": "59269387649369", "iPhone 16 Plus": "59269387682137", "iPhone 16": "59269387714905", "iPhone 15 Pro Max": "59269387747673", "iPhone 15 Pro": "59269387780441", "iPhone 15": "59269387813209", "iPhone 14 Pro Max": "59269387845977", "iPhone 14 Pro": "59269387878745", "iPhone 14 Plus": "59269387911513", "iPhone 14": "59269387944281", "iPhone 13 Pro Max": "59269387977049", "iPhone 13 Pro": "59269388009817", "iPhone 13": "59269388042585"}, "GREY": {"iPhone 17 Pro Max": "59269388075353", "iPhone 17 Pro": "59269388108121", "iPhone 17": "59269388140889", "iPhone 16 Pro Max": "59269388173657", "iPhone 16 Pro": "59269388206425", "iPhone 16 Plus": "59269388239193", "iPhone 16": "59269388271961", "iPhone 15 Pro Max": "59269388304729", "iPhone 15 Pro": "59269388337497", "iPhone 15": "59269388370265", "iPhone 14 Pro Max": "59269388403033", "iPhone 14 Pro": "59269388435801", "iPhone 14 Plus": "59269388468569", "iPhone 14": "59269388501337", "iPhone 13 Pro Max": "59269388534105", "iPhone 13 Pro": "59269388566873", "iPhone 13": "59269388599641"}, "GOLD": {"iPhone 17 Pro Max": "59269388632409", "iPhone 17 Pro": "59269388665177", "iPhone 17": "59269388697945", "iPhone 16 Pro Max": "59269388730713", "iPhone 16 Pro": "59269388763481", "iPhone 16 Plus": "59269388796249", "iPhone 16": "59269388829017", "iPhone 15 Pro Max": "59269388861785", "iPhone 15 Pro": "59269388894553", "iPhone 15": "59269388927321", "iPhone 14 Pro Max": "59269388960089", "iPhone 14 Pro": "59269388992857", "iPhone 14 Plus": "59269389025625", "iPhone 14": "59269389058393", "iPhone 13 Pro Max": "59269389091161", "iPhone 13 Pro": "59269389123929", "iPhone 13": "59269389156697"}, "ORANGE": {"iPhone 17 Pro Max": "59269389189465", "iPhone 17 Pro": "59269389222233", "iPhone 17": "59269389255001", "iPhone 16 Pro Max": "59269389287769", "iPhone 16 Pro": "59269389320537", "iPhone 16 Plus": "59269389353305", "iPhone 16": "59269389386073", "iPhone 15 Pro Max": "59269389418841", "iPhone 15 Pro": "59269389451609", "iPhone 15": "59269389484377", "iPhone 14 Pro Max": "59269389517145", "iPhone 14 Pro": "59269389549913", "iPhone 14 Plus": "59269389582681", "iPhone 14": "59269389615449", "iPhone 13 Pro Max": "59269389648217", "iPhone 13 Pro": "59269389680985", "iPhone 13": "59269389713753"}, "PINK": {"iPhone 17 Pro Max": "59269389746521", "iPhone 17 Pro": "59269389779289", "iPhone 17": "59269389812057", "iPhone 16 Pro Max": "59269389844825", "iPhone 16 Pro": "59269389877593", "iPhone 16 Plus": "59269389910361", "iPhone 16": "59269389943129", "iPhone 15 Pro Max": "59269389975897", "iPhone 15 Pro": "59269390008665", "iPhone 15": "59269390074201", "iPhone 14 Pro Max": "59269390106969", "iPhone 14 Pro": "59269390139737", "iPhone 14 Plus": "59269390172505", "iPhone 14": "59269390205273", "iPhone 13 Pro Max": "59269390238041", "iPhone 13 Pro": "59269390270809", "iPhone 13": "59269390303577"}};

  let currentColor = 'BLACK';
  let currentSize = 'iPhone 17 Pro Max';
  let selectedTier = 2; // Default to 2 (Buy 2 is checked by default)
  let isSubmitting = false;

  // Initialize initial state from DOM
  const checkedColorInput = document.querySelector('input[name="Color"]:checked');
  if (checkedColorInput && checkedColorInput.value) {
    currentColor = checkedColorInput.value.toUpperCase();
  }

  const sizeSelect = document.querySelector('select[name="options[Size]"]');
  if (sizeSelect && sizeSelect.value) {
    currentSize = sizeSelect.value;
  }

  const checkedQty = document.querySelector('input[name="quantity"]:checked');
  if (checkedQty && checkedQty.value) {
    selectedTier = parseInt(checkedQty.value, 10) || 2;
  }

  // Helper to get variant ID
  function getVariantId(color, size) {
    const c = (color || currentColor || 'BLACK').trim().toUpperCase();
    const s = (size || currentSize || 'iPhone 17 Pro Max').trim();
    if (variantMap[c] && variantMap[c][s]) {
      return variantMap[c][s];
    }
    // Try case-insensitive lookup
    if (variantMap[c]) {
      for (const key in variantMap[c]) {
        if (key.toLowerCase() === s.toLowerCase()) {
          return variantMap[c][key];
        }
      }
      const firstKey = Object.keys(variantMap[c])[0];
      return variantMap[c][firstKey];
    }
    return '59269385519449';
  }

  // 1. Color Selection
  document.querySelectorAll('input[name="Color"], .product-form__input input[type="radio"]').forEach(radio => {
    radio.addEventListener('change', function() {
      if (this.checked) {
        currentColor = this.value.toUpperCase();
        updateSelection();
      }
    });
  });

  // Handle color pill button clicks
  document.querySelectorAll('.product-form__input label, .swatch-input__label').forEach(label => {
    label.addEventListener('click', function() {
      const forId = this.getAttribute('for');
      if (forId) {
        const inp = document.getElementById(forId);
        if (inp) {
          inp.checked = true;
          currentColor = inp.value.toUpperCase();
          updateSelection();
        }
      }
    });
  });

  // 2. Size Selection
  document.querySelectorAll('select[name="options[Size]"], .product-form__input--dropdown select').forEach(sel => {
    sel.addEventListener('change', function() {
      currentSize = this.value;
      updateSelection();
    });
  });

  // 3. SMART PACK Bundle Box Tier Selection
  function selectTier(tierNum) {
    selectedTier = tierNum;
    const radio = document.getElementById(`quantity${tierNum}-template--29891090252115__main`) ||
                  document.querySelector(`input[name="quantity"][value="${tierNum}"]`);
    if (radio) radio.checked = true;

    // Toggle selected classes
    document.querySelectorAll('.quantity-break').forEach(qb => {
      qb.classList.remove('selected', 'is-selected');
    });

    const activeCard = radio ? (radio.closest('.quantity-break') || document.querySelector(`label[for="${radio.id}"]`)) : null;
    if (activeCard) {
      activeCard.classList.add('selected', 'is-selected');
    }

    // Toggle sub-variant dropdown boxes
    const box1 = document.querySelector('#option-1-variants-template--29891090252115__main');
    const box2 = document.querySelector('#option-2-variants-template--29891090252115__main');
    if (box1) box1.style.display = (tierNum === 1 ? 'block' : 'none');
    if (box2) box2.style.display = (tierNum === 2 ? 'block' : 'none');

    // Sync prices
    if (activeCard) {
      const tierPriceEl = activeCard.querySelector('.quantity-break__price');
      const tierCompareEl = activeCard.querySelector('.quantity-break__compare-price');
      if (tierPriceEl) {
        const newPrice = tierPriceEl.innerHTML.trim();
        document.querySelectorAll('.main-price, .sticky-atc__price .price-item--sale, .sticky-atc__price .price-item--regular').forEach(el => {
          el.innerHTML = newPrice;
        });
      }
      if (tierCompareEl) {
        const newCompare = tierCompareEl.innerHTML.trim();
        document.querySelectorAll('.main-compare-price, .sticky-atc__price .price__compare-price s').forEach(el => {
          el.innerHTML = newCompare;
        });
      }
    }
  }

  document.querySelectorAll('.quantity-break, input[name="quantity"]').forEach(el => {
    el.addEventListener('click', function(e) {
      const radio = this.tagName === 'INPUT' ? this : this.querySelector('input[type="radio"]') || document.getElementById(this.getAttribute('for'));
      if (radio) {
        const val = parseInt(radio.value, 10) || 1;
        selectTier(val);
      }
    });
  });

  function updateSelection() {
    const vid = getVariantId(currentColor, currentSize);

    // Update all hidden inputs
    document.querySelectorAll('input[name="id"]').forEach(inp => {
      inp.value = vid;
    });

    // Update main gallery image to match selected color if image exists
    const imgMap = window.AETHOS_IMAGES || {};
    if (imgMap[currentColor]) {
      const mainImg = document.querySelector('.product__media-item.is-active img, .product__media-list img, media-gallery img');
      if (mainImg) {
        mainImg.src = imgMap[currentColor];
        mainImg.srcset = imgMap[currentColor];
      }
    }

    // Sync Tier 1 variant selectors if present
    const t1Color = document.querySelector('#option-1-variants-template--29891090252115__main select[name="options[Color]"]');
    if (t1Color) t1Color.value = currentColor;
    const t1Size = document.querySelector('#option-1-variants-template--29891090252115__main select[name="options[Size]"]');
    if (t1Size) t1Size.value = currentSize;
  }

  // 4. Resolve selected bundle items
  function getSelectedItems(isSticky) {
    let items = [];

    // If clicked from sticky ATC and sticky has a select
    if (isSticky) {
      const stickySelect = document.querySelector('.sticky-atc select');
      if (stickySelect && stickySelect.value) {
        items.push({ id: stickySelect.value, quantity: 1 });
        return items;
      }
    }

    if (selectedTier === 1) {
      const tier1Box = document.querySelector('#option-1-variants-template--29891090252115__main');
      let c = currentColor;
      let s = currentSize;
      if (tier1Box && tier1Box.style.display !== 'none') {
        const cSel = tier1Box.querySelector('select[name="options[Color]"]');
        const sSel = tier1Box.querySelector('select[name="options[Size]"]');
        if (cSel && cSel.value) c = cSel.value;
        if (sSel && sSel.value) s = sSel.value;
      }
      items.push({ id: getVariantId(c, s), quantity: 1 });
    } else if (selectedTier === 2) {
      const tier2Box = document.querySelector('#option-2-variants-template--29891090252115__main');
      if (tier2Box) {
        const itemBoxes = tier2Box.querySelectorAll('.quantity-break__selector-item');
        if (itemBoxes.length >= 2) {
          const c1Sel = itemBoxes[0].querySelector('select[name="options[Color]"]');
          const s1Sel = itemBoxes[0].querySelector('select[name="options[Size]"]');
          const c1 = (c1Sel && c1Sel.value) ? c1Sel.value : currentColor;
          const s1 = (s1Sel && s1Sel.value) ? s1Sel.value : currentSize;
          items.push({ id: getVariantId(c1, s1), quantity: 1 });

          const c2Sel = itemBoxes[1].querySelector('select[name="options[Color]"]');
          const s2Sel = itemBoxes[1].querySelector('select[name="options[Size]"]');
          const c2 = (c2Sel && c2Sel.value) ? c2Sel.value : currentColor;
          const s2 = (s2Sel && s2Sel.value) ? s2Sel.value : currentSize;
          items.push({ id: getVariantId(c2, s2), quantity: 1 });
        }
      }
      if (items.length < 2) {
        const vid = getVariantId(currentColor, currentSize);
        items = [
          { id: vid, quantity: 1 },
          { id: vid, quantity: 1 }
        ];
      }
    } else {
      items.push({ id: getVariantId(currentColor, currentSize), quantity: 1 });
    }

    return items;
  }

  // 5. UNIFIED ADD TO CART HANDLER
  function handleAddToCart(e) {
    if (e) {
      e.preventDefault();
      if (typeof e.stopPropagation === 'function') e.stopPropagation();
      if (typeof e.stopImmediatePropagation === 'function') e.stopImmediatePropagation();
    }

    if (isSubmitting) return false;
    isSubmitting = true;

    const isSticky = e && e.target && e.target.closest && e.target.closest('.sticky-atc');
    const mainBtn = document.getElementById('ProductSubmitButton-template--29891090252115__main') ||
                    document.querySelector('.product-form__submit') ||
                    document.querySelector('.main-product-atc');
    const stickyBtn = document.getElementById('StickyAtcSubmitButton-template--29891090252115__main') ||
                      document.querySelector('.sticky-atc__button button');

    const setBtnText = (txt) => {
      if (mainBtn) {
        mainBtn.disabled = true;
        mainBtn.classList.add('loading');
        const tEl = mainBtn.querySelector('.main-atc__label__text');
        if (tEl) tEl.textContent = txt;
        else mainBtn.textContent = txt;
      }
      if (stickyBtn) {
        stickyBtn.disabled = true;
        stickyBtn.classList.add('loading');
        const tEl = stickyBtn.querySelector('.sticky-atc__label__text');
        if (tEl) tEl.textContent = txt;
        else stickyBtn.textContent = txt;
      }
    };

    const resetBtnText = () => {
      if (mainBtn) {
        mainBtn.disabled = false;
        mainBtn.classList.remove('loading');
        const tEl = mainBtn.querySelector('.main-atc__label__text');
        if (tEl) tEl.textContent = 'Add to cart';
        else mainBtn.textContent = 'Add to cart';
      }
      if (stickyBtn) {
        stickyBtn.disabled = false;
        stickyBtn.classList.remove('loading');
        const tEl = stickyBtn.querySelector('.sticky-atc__label__text');
        if (tEl) tEl.textContent = 'Add to cart';
        else stickyBtn.textContent = 'Add to cart';
      }
    };

    setBtnText('ADDING...');

    const itemsToAdd = getSelectedItems(isSticky);

    // Update hidden inputs for native form reference
    if (itemsToAdd.length > 0) {
      document.querySelectorAll('input[name="id"]').forEach(inp => {
        inp.value = itemsToAdd[0].id;
      });
    }

    // Analytics Tracking
    try {
      const cfg = window.AETHOS_CONFIG || {};
      const baseCents = cfg.basePrice || 2700;
      const currentCurrency = cfg.currency || (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) || 'GBP';
      const multiplier = (itemsToAdd.length === 1 ? 1 : 1.8);
      const totalPrice = parseFloat((baseCents * multiplier / 100).toFixed(2));
      const firstVid = itemsToAdd[0].id;

      if (typeof fbq === 'function') {
        fbq('track', 'AddToCart', {
          content_name: 'Smart LED E-Ink Case',
          content_ids: itemsToAdd.map(i => i.id),
          content_type: 'product',
          value: totalPrice,
          currency: currentCurrency
        });
      }

      if (typeof ttq === 'object' && typeof ttq.track === 'function') {
        ttq.track('AddToCart', {
          content_id: firstVid,
          content_type: 'product',
          quantity: itemsToAdd.length,
          price: parseFloat((baseCents / 100).toFixed(2)),
          value: totalPrice,
          currency: currentCurrency
        });
      }
    } catch (err) {
      console.warn('Analytics tracking error:', err);
    }

    const payload = {
      items: itemsToAdd
    };

    fetch((window.routes && window.routes.cart_add_url) || '/cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json'
      },
      body: JSON.stringify(payload)
    })
    .then(res => res.json())
    .then(data => {
      isSubmitting = false;
      resetBtnText();

      if (data.status && data.status !== 200) {
        alert(data.description || 'Could not add to cart.');
        return;
      }

      window.location.href = (window.routes && window.routes.cart_url) || '/cart';
    })
    .catch(err => {
      console.error('Error adding to cart:', err);
      isSubmitting = false;
      resetBtnText();
      window.location.href = (window.routes && window.routes.cart_url) || '/cart';
    });

    return false;
  }

  // 6. ATTACH LISTENERS
  function attachAddToCartListeners() {
    const productForm = document.getElementById('product-form-template--29891090252115__main');
    if (productForm) {
      productForm.addEventListener('submit', handleAddToCart, true);
    }

    const mainAtcBtn = document.getElementById('ProductSubmitButton-template--29891090252115__main') ||
                       document.querySelector('.product-form__submit') ||
                       document.querySelector('.main-product-atc');
    if (mainAtcBtn) {
      mainAtcBtn.addEventListener('click', handleAddToCart, true);
    }

    const stickyAtcBtn = document.getElementById('StickyAtcSubmitButton-template--29891090252115__main') ||
                         document.querySelector('.sticky-atc__button button');
    if (stickyAtcBtn) {
      stickyAtcBtn.addEventListener('click', handleAddToCart, true);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', attachAddToCartListeners);
  } else {
    attachAddToCartListeners();
  }

  // 7. Initialize Slick Carousel for 10,000+ Happy Customers
  if (typeof jQuery !== 'undefined') {
    jQuery(function($) {
      const sliderContainer = $("#image-slider-container-template--29891090252115__image_slider_iipUwe");
      if (sliderContainer.length && typeof sliderContainer.slick === 'function') {
        if (!sliderContainer.hasClass('slick-initialized')) {
          sliderContainer.slick({
            slidesToShow: 3,
            slidesToScroll: 1,
            infinite: true,
            autoplay: true,
            autoplaySpeed: 4000,
            arrows: true,
            prevArrow: '.slider-arrow-prev',
            nextArrow: '.slider-arrow-next',
            dots: true,
            responsive: [
              {
                breakpoint: 768,
                settings: {
                  slidesToShow: 1,
                  slidesToScroll: 1
                }
              }
            ]
          });
        }
      }
    });
  }

  // 8. Accordions (Details toggle)
  document.querySelectorAll('details summary').forEach(summary => {
    summary.addEventListener('click', function(e) {
      const details = this.parentElement;
      if (details.hasAttribute('open')) {
        details.removeAttribute('open');
      } else {
        details.setAttribute('open', '');
      }
      e.preventDefault();
    });
  });

  // 9. Initial setup
  selectTier(selectedTier);
  updateSelection();
})();